import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetorajshthanurbania() {



    const cardData =
    {
        keyword: 'Pune to Rajasthan Urbania Rental Service',
        heading: 'Urbania on rent in pune: Pune to Rajasthan Urbania Rental Service',
        headingDescription: 'Urbania On Rent in Pune offers premium and reliable Pune to Rajasthan Urbania Rental Service for families, corporate groups, tourists, and event travelers planning long-distance journeys to Rajasthan. Our well‑maintained Force Urbania fleet provides spacious seating, air‑conditioned comfort, ample luggage space, and smooth highway performance, making it ideal for sightseeing tours, group travel, weddings, airport transfers, and outstation trips from Pune to key Rajasthan destinations like Jaipur, Udaipur, Jodhpur, and Ajmer. With professional chauffeurs experienced in interstate travel, flexible one‑way and round‑trip rental options, and convenient doorstep pickup from major areas including Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Kothrud, Pimpri Chinchwad, and Pune Airport, we ensure a safe, punctual, and stress‑free travel experience. Backed by 24/7 booking support, transparent pricing, and trusted service, Urbania On Rent in Pune stands out as the preferred choice for Pune to Rajasthan Urbania rental services.',

        top: 'Top Places to Visit in Rajasthan with Pune on rent in pune',


"topPlaces": [
  {
    "title": "City Palace, Jaipur",
    "description": "City Palace in Jaipur is a grand architectural complex that blends Rajasthani and Mughal styles. Built by Maharaja Sawai Jai Singh II, it houses royal courtyards, gardens, museums, and the famous Chandra Mahal. Visitors can explore artifacts, royal costumes, and historical paintings, offering a glimpse into the regal lifestyle of Jaipur’s royal family. Its intricate architecture and vibrant interiors make it a must-visit cultural landmark."
  },
  {
    "title": "Amber Fort",
    "description": "Amber Fort, located near Jaipur, is a majestic hilltop fort known for its artistic Hindu-style architecture, sprawling courtyards, mirror work, and ornate palaces. Built by Raja Man Singh I, it offers breathtaking views of Maota Lake and the surrounding hills. Visitors can enjoy elephant rides, light-and-sound shows, and photography, making it a perfect blend of history, culture, and scenic beauty."
  },
  {
    "title": "Hawa Mahal",
    "description": "Hawa Mahal, also called the Palace of Winds, is an iconic five-story pink sandstone façade in Jaipur designed for royal women to observe street life without being seen. Its 953 small windows (jharokhas) allow cool breezes to pass through, making it architecturally unique. The structure is one of Rajasthan’s most photographed landmarks and a symbol of Jaipur’s royal heritage."
  },
  {
    "title": "Mehrangarh Fort, Jodhpur",
    "description": "Mehrangarh Fort is a massive 15th-century fort in Jodhpur, perched on a hill overlooking the Blue City. The fort features intricate carvings, expansive courtyards, museums showcasing royal artifacts, and stunning views of the city. It is known for its impressive gates, palaces like Sheesh Mahal, and cultural events, offering visitors a deep insight into Rajasthan’s warrior history."
  },
  {
    "title": "Jaisalmer Fort",
    "description": "Jaisalmer Fort, also called Sonar Quila or Golden Fort, is a UNESCO World Heritage Site built from golden sandstone. Its massive walls, narrow lanes, palaces, temples, and bustling markets create a living fort experience. The fort’s architectural brilliance and desert backdrop make it one of the most unique attractions in Rajasthan."
  },
  {
    "title": "Lake Pichola, Udaipur",
    "description": "Lake Pichola is a picturesque artificial lake in Udaipur, surrounded by palaces, temples, and ghats. Boat rides offer stunning views of the City Palace, Jag Mandir, and the scenic Aravalli hills. The tranquil waters and romantic ambiance make it a favorite destination for couples, photographers, and travelers seeking serenity amidst Rajasthan’s royal charm."
  },
  {
    "title": "City Palace, Udaipur",
    "description": "City Palace in Udaipur is an architectural marvel overlooking Lake Pichola. It features grand courtyards, balconies, museums, and gardens that showcase the Mewar dynasty’s royal heritage. Visitors can explore the intricately decorated halls, royal artifacts, and stunning views of the lake and city, making it a cultural and historical treasure."
  },
  {
    "title": "Kumbhalgarh Fort",
    "description": "Kumbhalgarh Fort, a UNESCO World Heritage Site, is known for its massive walls stretching over 36 km, making it one of the longest in the world. Located in the Aravalli hills, the fort offers panoramic views, ancient temples, palaces, and strategic bastions. It is historically significant as the birthplace of Maharana Pratap and is a key destination for history enthusiasts and trekkers."
  },
  {
    "title": "Pushkar Lake and Brahma Temple",
    "description": "Pushkar is famous for its sacred lake surrounded by 52 ghats and the only Brahma Temple in India. Pilgrims come to take holy dips, perform rituals, and participate in the vibrant Pushkar Camel Fair. The town’s colorful bazaars, desert ambiance, and spiritual significance make it a unique cultural experience."
  },
  {
    "title": "Chittorgarh Fort",
    "description": "Chittorgarh Fort, a UNESCO World Heritage Site, is one of India’s largest forts, renowned for its history of valor, sieges, and heroism. It houses palaces, temples, towers, and memorials of legendary Rajput queens and warriors. The fort’s architecture, massive gates, and panoramic views reflect Rajasthan’s martial legacy and make it a must-visit for history and culture enthusiasts."
  }
],




"services": [
{
"name": "Pune to Rajasthan Urbania Rental Service",
"description": "Pune to Rajasthan Urbania Rental Service offers reliable and comfortable Urbania buses for long-distance travel from Pune to Rajasthan. Ideal for families, groups, and tourists, the service ensures spacious seating, clean interiors, ample luggage space, and experienced drivers for a smooth journey across states."
},
{
"name": "Rajasthan Urbania Hire from Pune",
"description": "Rajasthan Urbania Hire from Pune provides flexible rental options for one-way or round-trip travel to Rajasthan. With professional chauffeurs and well-maintained buses, it guarantees punctual pickups, safe driving, and a hassle-free travel experience."
},
{
"name": "Urbania Bus Rental Pune to Rajasthan",
"description": "Urbania Bus Rental Pune to Rajasthan features well-serviced buses suitable for long highway journeys. The service focuses on passenger comfort, reliability, and safety throughout the trip to Rajasthan."
},
{
"name": "Urbania AC Bus Rajasthan Tour",
"description": "Urbania AC Bus Rajasthan Tour offers fully air-conditioned buses for a comfortable and climate-controlled journey, making long-distance travel pleasant for all passengers."
},
{
"name": "Family Rajasthan Tour Urbania Pune",
"description": "Family Rajasthan Tour Urbania Pune provides spacious, safe, and comfortable buses for families traveling together, ensuring an enjoyable and stress-free journey."
},
{
"name": "Corporate Rajasthan Tour Urbania Pune",
"description": "Corporate Rajasthan Tour Urbania Pune offers organized and professional transportation for corporate groups and official tours, with a focus on punctuality, comfort, and seamless coordination."
},
{
"name": "Luxury Urbania Rajasthan Tour",
"description": "Luxury Urbania Rajasthan Tour delivers a premium travel experience with modern interiors, plush seating, and superior comfort, perfect for travelers seeking a refined and relaxed journey."
},
{
"name": "Affordable Rajasthan Tour Urbania Pune",
"description": "Affordable Rajasthan Tour Urbania Pune provides budget-friendly bus rental options without compromising safety or comfort, making it suitable for groups and cost-conscious travelers."
},
{
"name": "Chauffeur Driven Urbania Rajasthan Tour",
"description": "Chauffeur Driven Urbania Rajasthan Tour ensures a stress-free journey with trained, verified drivers experienced in long-distance travel and inter-state routes."
},
{
"name": "Best Rajasthan Urbania Package Pune",
"description": "Best Rajasthan Urbania Package Pune offers complete travel solutions including comfortable buses, professional drivers, and well-planned itineraries for Rajasthan tours."
},
{
"name": "Group Travel Rajasthan Urbania",
"description": "Group Travel Rajasthan Urbania provides spacious and coordinated transportation for large groups, ensuring everyone travels together comfortably and safely."
},
{
"name": "Tourist Urbania Hire Pune",
"description": "Tourist Urbania Hire Pune offers reliable bus services for sightseeing and tour packages, focusing on comfort, safety, and enjoyable travel experiences for tourists."
},
{
"name": "Pune Rajasthan Bus Booking",
"description": "Pune Rajasthan Bus Booking allows easy and hassle-free reservation of Urbania buses, ensuring timely pickups and well-organized journeys for all travelers."
},
{
"name": "Trusted Rajasthan Urbania Service",
"description": "Trusted Rajasthan Urbania Service provides safe, dependable, and customer-focused bus rental services, making it a reliable choice for travel from Pune to Rajasthan."
},
{
"name": "Long Distance Urbania Hire Pune",
"description": "Long Distance Urbania Hire Pune specializes in interstate travel, offering comfortable buses, professional drivers, and well-managed schedules for long-haul journeys."
}
],
"tableData": [
["Pune to Rajasthan Urbania Rental Service", "Rajasthan Urbania Hire from Pune"],
["Urbania Bus Rental Pune to Rajasthan", "Urbania AC Bus Rajasthan Tour"],
["Family Rajasthan Tour Urbania Pune", "Corporate Rajasthan Tour Urbania Pune"],
["Luxury Urbania Rajasthan Tour", "Affordable Rajasthan Tour Urbania Pune"],
["Chauffeur Driven Urbania Rajasthan Tour", "Best Rajasthan Urbania Package Pune"],
["Group Travel Rajasthan Urbania", "Tourist Urbania Hire Pune"],
["Pune Rajasthan Bus Booking", "Trusted Rajasthan Urbania Service"],
["Long Distance Urbania Hire Pune", ""]
],



whychoose : [
    {
        "WhyChooseheading": "Pune to Rajasthan Urbania Rental Service for Comfortable Travel",
        "WhyChoosedescription": "Pune to Rajasthan Urbania Rental Service is ideal for long-distance travel, family trips, group tours, corporate journeys, and leisure travel, ensuring a comfortable and hassle-free experience."
    },
    {
        "WhyChooseheading": "Spacious and Modern Urbania Buses",
        "WhyChoosedescription": "Our Urbania buses for Pune to Rajasthan travel are equipped with air-conditioning, reclining seats, ample legroom, and sufficient luggage space for a smooth journey across states."
    },
    {
        "WhyChooseheading": "Experienced Drivers for Interstate Travel",
        "WhyChoosedescription": "All drivers are trained and experienced in long-distance interstate travel from Pune to Rajasthan, ensuring safe driving, timely arrivals, and a stress-free journey."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Pune to Rajasthan Urbania Rental Service offers competitive rates with no hidden charges, making long-distance travel economical and reliable."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "We provide round-the-clock booking assistance and dedicated customer support for inquiries, reservations, and last-minute travel needs."
    },
    {
        "WhyChooseheading": "Flexible Travel Packages",
        "WhyChoosedescription": "Available for one-way trips, round trips, multi-day tours, corporate journeys, and customized itineraries as per your requirements."
    },
    {
        "WhyChooseheading": "Clean and Well-Maintained Vehicles",
        "WhyChoosedescription": "All Urbania buses are regularly cleaned, sanitized, and well-maintained to ensure passenger comfort and hygiene throughout the journey."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Service",
        "WhyChoosedescription": "Our Pune to Rajasthan Urbania Rental Service guarantees on-time departures, dependable travel support, and a smooth overall experience."
    }
]
}
const faqData = [
    {
        question: 'Can Pune to Rajasthan Urbania Rental Service be booked for long-distance travel?',
        answer: 'Yes, it is suitable for long-distance journeys, family trips, group travel, corporate tours, and interstate travel.'
    },
    {
        question: 'How can I book Pune to Rajasthan Urbania Rental Service?',
        answer: 'Bookings can be made via phone, WhatsApp, or online for quick and convenient reservations.'
    },
    {
        question: 'Why choose Pune to Rajasthan Urbania Rental Service?',
        answer: 'This service offers spacious seating, professional drivers, clean vehicles, flexible travel plans, and transparent pricing.'
    },
    {
        question: 'Are drivers experienced for the Pune to Rajasthan route?',
        answer: 'Yes, all drivers are licensed, trained, and experienced in interstate routes including Pune to Rajasthan.'
    },
    {
        question: 'Can pickup and drop locations be customized?',
        answer: 'Absolutely. Flexible pickup and drop-off locations are available across Pune and nearby areas.'
    },
    {
        question: 'Is Pune to Rajasthan Urbania Rental Service available 24/7?',
        answer: 'Yes, booking services and customer support are available 24/7.'
    },
    {
        question: 'Are hygiene and safety standards maintained?',
        answer: 'Yes, all buses are thoroughly cleaned, sanitized, and well-maintained for passenger safety.'
    },
    {
        question: 'What payment options are accepted?',
        answer: 'Payments can be made via UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing.'
    },
    {
        question: 'Is customer support available during the journey?',
        answer: 'Yes, dedicated customer support is available throughout the journey.'
    },
    {
        question: 'Is this service suitable for families and corporate groups?',
        answer: 'Yes, Pune to Rajasthan Urbania Rental Service is ideal for families, corporate groups, and large travel parties.'
    }
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Rohit Sharma',
        feedback: 'Our Pune to Rajasthan journey was extremely comfortable. The Urbania bus was spacious, clean, and perfect for long-distance interstate travel.',
        rating: 5
    },
    {
        id: 2,
        name: 'Ms. Priya Singh',
        feedback: 'Professional service and experienced driver. Pune to Rajasthan Urbania Rental Service made our multi-day trip smooth and enjoyable.',
        rating: 5
    }
];












































































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];














const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Rajasthan Urbania Rental Service",
  "image": "https://urbaniaonrentpune.in/assets/images/pune-rajasthan-urbania.jpg",
  "description": "Pune to Rajasthan Urbania Rental Service offers AC Urbania buses for one-way or round-trip travel, corporate trips, family tours, pilgrimage journeys, and group travel. Chauffeur-driven Urbania buses ensure safe, comfortable, and convenient transportation from Pune to Rajasthan.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "950",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "15000",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/pune-to-rajasthan-urbania-rental-service"
  }
};




    return (
        <div>
<Helmet>
  <title>
    Call:+91 9209423113 | Pune to Rajasthan Urbania Rental Service | AC Urbania Bus One Way & Round Trip 
  </title>

  <meta
    name="description"
    content="Book Pune to Rajasthan Urbania Rental Service for one-way or round-trip travel, corporate trips, family tours, pilgrimage journeys, and group travel. AC Urbania buses with chauffeur-driven service provide safe, comfortable, and convenient transportation from Pune to Rajasthan."
  />

  <meta
    name="keywords"
    content="Pune to Rajasthan Urbania Rental Service, Rajasthan Urbania Hire from Pune, Urbania Bus Rental Pune to Rajasthan, Urbania AC Bus Rajasthan Tour, Family Rajasthan Tour Urbania Pune, Corporate Rajasthan Tour Urbania Pune, Luxury Urbania Rajasthan Tour, Affordable Rajasthan Tour Urbania Pune, Chauffeur Driven Urbania Rajasthan Tour, Best Rajasthan Urbania Package Pune, Group Travel Rajasthan Urbania, Tourist Urbania Hire Pune, Pune Rajasthan Bus Booking, Trusted Rajasthan Urbania Service, Long Distance Urbania Hire Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/90.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetorajshthanurbania;